import { defineComponent as x, computed as w, ref as u, reactive as B, watch as f, onMounted as T, onBeforeUnmount as $, createElementBlock as v, openBlock as m, Fragment as b, createElementVNode as r, createVNode as j, unref as q, normalizeStyle as A, createCommentVNode as N, withModifiers as I, toDisplayString as k, renderList as P, normalizeClass as z } from "vue";
import { ScalarIconTextAlignLeft as H } from "@scalar/icons";
import { EditorClasses as L } from "@scalar-org/css";
const M = { class: "header" }, D = { class: "container" }, F = {
  key: 0,
  class: "level-1"
}, R = ["id"], U = ["href", "onClick"], K = /* @__PURE__ */ x({
  __name: "TableOfContents",
  props: {
    headings: {},
    pageTitle: {}
  },
  setup(s) {
    const p = s, g = w(
      () => Object.values(p.headings || {}).filter((e) => e.level === 1 || e.level === 2 || e.level === 3).map((e) => e.slug)
    ), o = u(""), a = u(""), n = B({}), c = w(
      () => Object.values(n).sort((e, t) => e.order - t.order)
    ), h = u([]), y = u(0);
    function C() {
      Object.keys(n).forEach((e) => {
        g.value.includes(e) || delete n[e];
      }), g.value.forEach((e, t) => {
        n[e] = {
          id: e,
          inView: n[e]?.inView ?? !1,
          order: t
        };
      });
    }
    f(g, () => C(), { immediate: !0, deep: !0 });
    const O = (e) => {
      e.forEach((t) => {
        if (n[t.target.id] && (n[t.target.id].inView = t.isIntersecting), a.value = t.target.id, !t.isIntersecting && t.target.getBoundingClientRect().top >= window.innerHeight * 0.2 && Object.values(n).every((d) => !d.inView)) {
          const d = c.value.findIndex(
            (S) => S.id === t.target.id
          );
          d >= 1 && (a.value = c.value[d - 1].id);
        }
      });
    };
    f(
      [a, c],
      () => {
        const e = c.value.find((t) => t.inView);
        if (e) {
          o.value = e.id;
          return;
        }
        if (a.value) {
          o.value = a.value;
          return;
        }
      },
      { immediate: !0, deep: !0 }
    );
    let i;
    function E() {
      i && i.disconnect(), document.querySelectorAll(
        '[data-scalar-type="heading"][data-level="1"], [data-scalar-type="heading"][data-level="2"], [data-scalar-type="heading"][data-level="3"]'
      ).forEach((t) => i?.observe(t));
    }
    T(() => {
      i = new IntersectionObserver(O, {
        // threshold: 1,
        // rootMargin: '-20%',
      }), E();
    }), $(() => {
      i?.disconnect();
    }), f(
      () => Object.keys(p.headings || {}),
      () => {
        h.value = [], E();
      }
    );
    function V(e) {
      o.value = e.slug, window.location.replace(`#${e.slug}`), document.getElementById(e.slug)?.scrollIntoView();
    }
    function _() {
      document.querySelector(`.${L.PageTitle} h1`)?.scrollIntoView();
    }
    return f(o, () => {
      const e = h.value.find(
        (t) => t.querySelector(".anchor")?.getAttribute("href") === `#${o.value}`
      );
      e && (y.value = e.offsetTop);
    }), (e, t) => (m(), v(b, null, [
      r("div", M, [
        j(q(H)),
        t[0] || (t[0] = r("h4", null, "On This Page", -1))
      ]),
      r("div", D, [
        r("div", {
          class: "outline-marker",
          style: A({
            transform: `translateY(${y.value}px)`
          })
        }, null, 4),
        r("ul", null, [
          Object.keys(s.headings || {}).length === 0 ? (m(), v("li", F, [
            r("a", {
              class: "anchor",
              href: "#",
              onClick: I(_, ["prevent"])
            }, k(s.pageTitle), 1)
          ])) : N("", !0),
          (m(!0), v(b, null, P(s.headings, (l) => (m(), v("li", {
            id: l.uid,
            key: l.uid,
            ref_for: !0,
            ref_key: "tocItems",
            ref: h,
            class: z([
              `level-${l.level}`,
              `toc-indent-${l.level}`,
              { active: o.value === l.slug }
            ])
          }, [
            r("a", {
              class: "anchor",
              href: `#${l.slug}`,
              onClick: I(() => V(l), ["prevent"])
            }, k(l.name), 9, U)
          ], 10, R))), 128))
        ])
      ])
    ], 64));
  }
});
export {
  K as default
};
